export default {
  "___header_menu-header_account-plan-settings": "",
  "___header_menu-item_my-profile": "",
  "___header_menu-item_my-accounts": "",
  "___header_menu-item-resource-center": "",
  "___header_menu-item-id": "",
  "___header_menu-item_my-documents": "",
  "header_menu-item_personal-information": "Personal Info",
  "header_menu-item_my-documents": "My Stored Documents",
  "___header_menu-item_payment-banking": "",
  "___header_menu-item_communications": "",
  "___header_menu-item_see-all-settings": "",
  "header_menu-item_logout": "Sign Out",

  // STEPPER WRAPPER VARIANT
  "___header_stepper-wrapper_menu-item_home": "",
  "___header_stepper-wrapper_menu-item_contact-us": "",

  // NOTIFICATIONS FOR NOW
  "notifications_page-title": "Notifications",
  "notifications_page-description": "",
};